import { EventTrackingData } from '../../EventTracking/EventTracking.types';
import { PickupStatsAlertsProps } from '../PickupStatsAlerts.types';

export const MockBookingStatsLabels = {
  heading: 'Event Bookings Detail',
  date: 'DATE',
  percentPickedUp: '% PICKED UP (DAILY)',
  totalPickedUp: 'TOTAL (PICKUP/CONTRACTED)',
  totals: 'TOTAL',
};

export const MockGroupRatesLabels = {
  heading: 'Group Rates',
  perNight: 'USD / night',
};

export const PickupStatsBackPopOver = {
  heading: 'Go to Event Details?',
  message: 'There are unsaved changes for this property. If you leave this page, all the data entered will be lost.',
  cancelCtaLabel: 'Cancel',
  leaveCtaLabel: 'Leave Anyway',
};

export const MockEmailNotificationLabels = {
  heading: 'Email Notifications',
  backLabel: 'Back',
  addRecipientsHeading: 'Add Recipients',
  addRecipientsHelperText: 'Enter email addresses to receive pickup stats alerts.',
  emailLabel: 'Email Address',
  emailPlaceholder: 'Enter email address',
  addEmailCta: 'Add',
  recipientsTableHeading: 'Recipient',
  recipientsTableHelperText: 'Email Address',
  frequencyLabel: 'Frequency',
  frequencyOptions: [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
  ],
  milestoneLabel: 'Milestone',
  milestoneOptions: [
    { label: '25%', value: '25' },
    { label: '50%', value: '50' },
    { label: '75%', value: '75' },
    { label: '90%', value: '90' },
  ],
  cancelCta: 'Cancel',
  saveCta: 'Save',
  alertSuccessMessage: 'Alert saved successfully.',
  emailErrorText: 'Email is required.',
  emailInvalidErrorText: 'Please enter a valid email address.',
  emailDuplicateErrorText: 'This email has already been added',
  maxRecipientsErrorText: 'Enter up to 20 emails',
  pickupStatsBackPopOver: PickupStatsBackPopOver,
  pastStartDateHeading:
    "You cannot set up an email alert for this group because the group's start/arrival date is in the past.",
  pastStartDateText: 'Email notification will not be provided after the arrival date.',
  recipientValidationError: 'You have not selected any alerts for the email highlighted here.',
  emailMaxLengthErrorText: 'Alert Email(s) must be 50 characters or less',
};

export const MockEventTrackingData: EventTrackingData[] = [
  {
    propertyName: 'New York Marriott Marquis',
    propertyIndex: 0,
    bookingStatsData: {
      availabilityList: [
        {
          startDate: '2026-07-22',
          sold: 11,
          authorized: 60,
          percentageOfRoomsSold: 18,
        },
        {
          startDate: '2026-07-23',
          sold: 9,
          authorized: 60,
          percentageOfRoomsSold: 15,
        },
        {
          startDate: '2026-07-24',
          sold: 7,
          authorized: 60,
          percentageOfRoomsSold: 11,
        },
        {
          startDate: '2026-07-25',
          sold: 1,
          authorized: 60,
          percentageOfRoomsSold: 1,
        },
        {
          startDate: '2026-07-26',
          sold: 1,
          authorized: 60,
          percentageOfRoomsSold: 1,
        },
        {
          startDate: '2026-07-27',
          sold: 2,
          authorized: 60,
          percentageOfRoomsSold: 3,
        },
      ],
      totalRooms: 360,
      totalSold: 31,
      percentageOfRoomsSold: 8,
    },
    groupRatesData: [
      {
        groupCode: 'NYMNYMA',
        roomType: 'GENR',
        description: 'GENR',
        roomTypeDetail: {
          description: 'Guest room, 1 King',
        },
        rateAmounts: [
          {
            rateMode: {
              code: 'base-rate',
            },
            amount: {
              currency: 'USD',
              value: 7500,
              valueDecimalPoint: 2,
            },
          },
        ],
      },
      {
        groupCode: 'NYMNYMB',
        roomType: 'DBDB',
        description: 'DBDB',
        roomTypeDetail: {
          description: 'Guest room, 2 Double',
        },
        rateAmounts: [
          {
            rateMode: {
              code: 'base-rate',
            },
            amount: {
              currency: 'USD',
              value: 8000,
              valueDecimalPoint: 2,
            },
          },
        ],
      },
    ],
  },
];

export const MockPickupStatsAlertsProps: PickupStatsAlertsProps = {
  propertyIndex: 0,
  eventTrackingData: MockEventTrackingData,
  bookingStatsLabels: MockBookingStatsLabels,
  groupRatesLabels: MockGroupRatesLabels,
  emailNotificationLabels: MockEmailNotificationLabels,
  alertSubscriptionsByKey: {},
  onSave: async () => ({ success: true }),
  onCancel: () => {},
  pickupStatsResponseStatus: {
    hasData: true,
    hasError: false,
  },
  apiFailureText: 'We are experiencing technical difficulties.',
};
